import React, { ReactNode } from 'react';
import styled from 'styled-components';
import LineImage from '../../../../images/logo/sns/line-contained.png';
import Link from '@material-ui/core/Link';
import withStyles from '@material-ui/core/styles/withStyles';

const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledLink = withStyles((theme) => ({
  root: {
    marginLeft: theme.spacing(1),
    fontWeight: 'bold',
  },
}))(Link);

interface OfficialLineProps {
  children: ReactNode;
  href: string;
}

const LineLink = ({ children, href }: OfficialLineProps) => (
  <Root>
    <img src={LineImage} width={30} height={30} alt="LINE" />
    <StyledLink
      href={href}
      underline="always"
      color="textPrimary"
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
    </StyledLink>
  </Root>
);

export default LineLink;
